import script from "./LogoIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoIcon.vue?vue&type=script&lang=ts&setup=true"

import "./LogoIcon.vue?vue&type=style&index=0&id=6ced691e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ced691e"]])

export default __exports__